export default class CMSWindow {
    get mode() {
        return this._getmode();
    }

    get editMode() {
        return (this.mode == 'edit');
    }

    constructor() {
        let _mode = null;
        if (window.parent.location.href.match('\/previewedit\/')) {
            _mode = 'edit';
        } else if (window.parent.location.href.match('\/preview\/')) {
            _mode = 'preview';
        }

        this._getmode = function () {
            console.log(_mode);
            return _mode;
        }.bind(this);

    }
}